import { Box } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import withStyles from "@material-ui/core/styles/withStyles";
import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import {
  FORM_FIELD_ESTIMATE_AMOUNT,
  FORM_FIELD_ESTIMATE_DETAILS,
  FORM_FIELD_JOB_SHEET_NUMBER,
} from "../../constants/field";
import {
  DOCUMENT_TPYE_ID_AADHAAR,
  DOCUMENT_TPYE_ID_ESTIMATE,
  DOCUMENT_TPYE_ID_MOBILE_PHOTOS,
  MODAL_KEY_PREMIUM,
  NO_ACTIVE_POLICY_TO_CLAIM_TEXT,
} from "../../constants/index";
import { ReducerUtils } from "../../constants/reducers";
import { Utils } from "../../constants/utils";
import ApplicationContext from "../../context/index";
import {
  formFields,
  initialFormState,
  touchFieldsObject,
} from "../../defaultValues/index";
import {
  buildInitiateClaimPayload,
  buildSubmitClaimInput,
  buildSystemErrorMessage,
  getServiceCentreDetails,
} from "../../helpers/proposal";
import { getWebService, postWebService } from "../../helpers/server";
import {
  getLendingRoute,
  getQueryStringParameterValue,
  getStorageItem,
  logout,
  navigateToUrl,
  parseMessage,
  redirectWithBlank,
  setStorageItem,
} from "../../helpers/utils";
import useApi from "../../hooks/useApi";
import { validations } from "../../messages/validation";
import ProposalForm from "./indexForm";
import { useStyles } from "./indexFormStyles";

function Proposal({ classes: { loaderBox } }) {
  const refId = getQueryStringParameterValue("ref");
  const orderId = getStorageItem("proposalId") ?? null;
  const mobile = getStorageItem("mobile") ?? null;

  const orderDetails = useApi(
    orderId ? `lending/proposal?mobile=${mobile}` : "/data/no-order.json"
  );
  const { state, dispatch } = useContext(ApplicationContext);
  const history = useHistory();
  const { claim: claimId } = useParams();
  const [disabledAccordion, setDisabledAccordion] = useState(false);
  const [errorMessage, setErrorMessage] = useState(formFields);
  const [errors, setErrors] = useState([]);
  const [form, setForm] = useState(initialFormState);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isSearchCompleted, setIsSearchCompleted] = useState(true);
  /* const [modal, setModal] = useState({
    [MODAL_KEY_PREMIUM]: false,
    estimate_amount: false,
  }); */
  const [noSearchResultFound, setNoSearchResultFound] = useState([]);
  const [photo, setPhoto] = useState({ estimate: "", aadhaar: "", phone: "" });
  const [touchFields, setTouchFields] = useState(touchFieldsObject);

  const [getImageData, setGetImageData] = useState([]);
  const [getLength, setGetLength] = useState([]);
  useEffect(() => fetchProductConfig(), []);
  useEffect(() => {}, [orderDetails]);
  useEffect(() => {}, [photo.estimate]);
  useEffect(() => {}, [photo.aadhaar]);
  useEffect(() => {}, [photo.phone]);
  useEffect(
    () => validateRequiredInput(FORM_FIELD_ESTIMATE_DETAILS),
    [form[FORM_FIELD_ESTIMATE_DETAILS]]
  );
  useEffect(
    () => validateEstimateInput(FORM_FIELD_ESTIMATE_AMOUNT),
    [form[FORM_FIELD_ESTIMATE_AMOUNT]]
  );
  useEffect(
    () => validateRequiredInput(FORM_FIELD_JOB_SHEET_NUMBER),
    [form[FORM_FIELD_JOB_SHEET_NUMBER]]
  );
  /* const handleClose = (flag = false, keyname = MODAL_KEY_PREMIUM) =>
    setModal({ ...modal, [keyname]: flag }); */

  const handleOnClose = (event, reason, modalKey = MODAL_KEY_PREMIUM) => {
    // Preventing from closing dialog either on escape key press and backdrop click
    if (Utils.dialogOnCloseReasons.indexOf(reason) > -1) {
      event.preventDefault();
    }
  };

  /* const changeOptionBaseOnValue = async (search, field) => {
    // TODO: Need to make an API call using field and response need to populate accordingly like makes, models, variants
  }; */

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  const handleChange = (event) =>
    setFormState(event.target.name, event.target.value);

  const doForceLogout = () => {
    // Here setTimeout has been added in order to introduced some delay so that dealer should be able to read error message clearly before redirecting it to login page
    setTimeout(() => {
      logout();
      navigateTo("/");
    }, 1000);
  };

  const cbError = ({ data: { error_msg }, code = 400 }, modalKey = "") => {
    setIsFormSubmitted(false);

    const message = parseMessage(error_msg);
    if (Array.isArray(message)) {
      setErrors(message);
    } else {
      let messageArray = [];
      messageArray.push(message);
      setErrors(messageArray);
    }

    if (code === 401) {
      doForceLogout();
    }
  };

  const fetchProductConfig = async () => {
    refId ? await fetchOrderDetails() : setIsLoaded(true);
  };

  const navigateTo = (pathname) => history.push({ pathname });

  const setErrorMessageState = (name, value) =>
    setErrorMessage({ ...errorMessage, [name]: value });

  const setFormState = (name, value) => setForm({ ...form, [name]: value });

  /* const setStateVariables = (key, isValid, message) => {
    setFormState("hasError", !isValid);
    setErrorMessageState(key, message);
    setTouchFieldsState(key, true);
  }; */

  const setTouchFieldsState = (name, value) =>
    setTouchFields({ ...touchFields, [name]: value });

  const validateRequiredInput = (fieldName) => {
    if (form[fieldName]) {
      setTouchFieldsState(fieldName, true);
      setErrorMessageState(fieldName, "");
    } else if (touchFields[fieldName] && !form[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  const validateEstimateInput = (fieldName) => {
    if (form[fieldName]) {
      setErrorMessageState(
        fieldName,
        Number(form[fieldName]) > form.invoice_amount
          ? `${validations[fieldName].valid} ₹${Number(
              form.invoice_amount
            ).toLocaleString("en")} (Phone Invoice Amount).`
          : ""
      );
      setTouchFieldsState(fieldName, true);
    } else if (touchFields[fieldName] && !form[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  const fetchRecentOrderForClaim = async () => {
    const response = await getWebService(`search/order/${form.mobile}`);
    const { data } = response.data;

    return data;
  };

  const fetchOrderDetails = async () => {
    setNoSearchResultFound([]);
    setDisabledAccordion(false);
    setIsSearchCompleted(false);
    setPhoto({ estimate: "", aadhaar: "", phone: "" });

    if (refId) {
      const response = await getWebService(`orders/${refId}/details/dealer`);
      const { data } = response.data;

      dispatchEvent(ReducerUtils.order.details, data);
      setDisabledAccordion(false);
      setIsSearchCompleted(true);
      setIsLoaded(true);
    } else {
      setNoSearchResultFound([NO_ACTIVE_POLICY_TO_CLAIM_TEXT]);
      dispatchEvent(ReducerUtils.order.details, null);
      setDisabledAccordion(true);
      setIsSearchCompleted(true);
      setIsLoaded(true);
    }
  };

  const searchClickHanlder = async () => {
    setNoSearchResultFound([]);
    setDisabledAccordion(false);
    setIsSearchCompleted(false);
    setPhoto({ estimate: "", aadhaar: "", phone: "" });

    const order = await fetchRecentOrderForClaim();

    if (order) {
      const response = await getWebService(`orders/${order.id}/details/dealer`);
      const { data } = response.data;

      dispatchEvent(ReducerUtils.order.details, data);
      setDisabledAccordion(false);
      setIsSearchCompleted(true);
    } else {
      setNoSearchResultFound([NO_ACTIVE_POLICY_TO_CLAIM_TEXT]);
      dispatchEvent(ReducerUtils.order.details, null);
      setDisabledAccordion(true);
      setIsSearchCompleted(true);
    }
  };

  const photoChangeHandler = (keyname, file) => {
    setPhoto({
      ...photo,
      [keyname]: file,
    });
  };

  const submitClaimInput = async (claimId) => {
    const response = await postWebService(
      `web/claim/inputs/${claimId}`,
      buildSubmitClaimInput(form)
    );

    const { data } = response.data;
  };

  const buildAadhaarPhotoRequestPayload = () => {
    const payload = new FormData();
    payload.append("delete_existing_document", 1);
    payload.append("document_type_id", DOCUMENT_TPYE_ID_AADHAAR);
    payload.append("claimDocuments[]", photo.aadhaar);
    payload.append("claimDocuments[]", photo.aadhaar);

    return payload;
  };

  const buildPhonePhotoRequestPayload = () => {
    const payload = new FormData();
    payload.append("delete_existing_document", 1);
    payload.append("document_type_id", DOCUMENT_TPYE_ID_MOBILE_PHOTOS);
    payload.append("claimDocuments[]", photo.phone);

    return payload;
  };

  const buildEstimatePhotoRequestPayload = () => {
    const payload = new FormData();
    payload.append("delete_existing_document", 1);
    payload.append("document_type_id", DOCUMENT_TPYE_ID_ESTIMATE);
    payload.append("estimate_document", photo.estimate);
    return payload;
  };

  const submitClaimDocument = async (claimId, payload) => {
    console.log(payload, "payload");
    await postWebService(`submit/estimate/${claimId}`, payload);
  };

  const submitClaim = async (claimId) => {
    let data = buildEstimatePhotoRequestPayload();
    const payload = {
      claimed_amount: Number(form?.estimate_amount),
      approved_amount: Number(form?.estimate_amount),
      estimated_by: Number(getServiceCentreDetails("service_centre_id")),
      estimate_details: form?.estimate_details,
      job_sheet_number: form?.job_sheet_number,
      mobile_damage_photos: getImageData,
    };
    const response = await postWebService(
      `web/claim/submit/${claimId}`,
      payload
    );
    const { success } = response.data;

    if (success) {
      navigateToUrl(getLendingRoute("dashboard"), history);
    }
  };

  const initiateClaim = async () => {
    try {
      setIsFormSubmitted(true);
      const response = await postWebService(
        `submit/estimate/${form.toffee_id}`,
        buildInitiateClaimPayload()
      );
      const {
        data: { claimId = null },
        success,
      } = response.data;

      if (success) {
        setStorageItem("claimId", claimId);
      }

      await submitClaimInput(claimId);
      await submitClaimDocument(claimId, buildAadhaarPhotoRequestPayload());
      await submitClaimDocument(claimId, buildPhonePhotoRequestPayload());
      await submitClaimDocument(claimId, buildEstimatePhotoRequestPayload());
      await submitClaim(claimId);

      setIsFormSubmitted(false);
    } catch (error) {
      cbError(
        error && error.response && error.response.data
          ? error.response.data
          : buildSystemErrorMessage()
      );
    }
  };

  const completeClaimHandler = async (claimId) => {
    setIsFormSubmitted(true);
    await submitClaimDocument(claimId, buildEstimatePhotoRequestPayload());
    await submitClaimDocument(claimId, buildPhonePhotoRequestPayload());
    await submitClaim(claimId);

    setIsFormSubmitted(false);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    refId && claimId ? completeClaimHandler(claimId) : initiateClaim();
  };

  const downloadFile = (url) => redirectWithBlank(url); //download(url, extractFileName(url));

  return isLoaded && state.orderDetails ? (
    <ProposalForm
      disabledAccordion={disabledAccordion}
      errorMessage={errorMessage}
      errors={errors}
      form={form}
      handleChange={handleChange}
      handleOnClose={handleOnClose}
      searchClickHanlder={searchClickHanlder}
      isFormSubmitted={isFormSubmitted}
      isSearchCompleted={isSearchCompleted}
      noSearchResultFound={noSearchResultFound}
      onSubmit={onSubmit}
      setForm={setForm}
      photo={photo}
      photoChangeHandler={photoChangeHandler}
      refId={refId}
      claimId={claimId}
      downloadFile={downloadFile}
      {...{ setGetImageData, setGetLength }}
    />
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(Proposal);
